import React from 'react';
import style from './style.scss';
import { Card } from '@rmwc/card';
import { classes } from './helpers';

export default function ( props ) {
    const { name, score, winner } = props;
    return (
        <div className={style.teamWrap}>
            <Card className={classes( style.teamCard, winner ? style.winner : null )}>
                <div className={style.teamName}>{name}</div>
                <Card className={style.teamScore}>{score}</Card>
            </Card>
        </div>
    )
}
